/**
 * React context for feature flags
 * @module lib/feature-flags/FeatureFlagContext
 */

import React from "react";

/**
 * Context for providing feature flag values throughout the app
 * @type {React.Context<Object>}
 */
const FeatureFlagContext = React.createContext({});

export default FeatureFlagContext;
